<template>
    <div class="pl-3 pr-3"></div>
</template>
<script>
  export default {
    name: 'ClinicDashboard',
    data () {
      return {
      }
    },
    computed: {
    },
    mounted () {
    },
    methods: {
    }
  }
</script>